module.exports = __webpack_public_path__ + "images/avatars/female/21.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/21.svg
// module id = NNCM
// module chunks = 153